/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Url_HintInputs */

const cs_xml_feed_url_hint = /** @type {(inputs: Xml_Feed_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuto adresu předejte portálu nebo partnerovi. Obsahuje tajný klíč — kdokoli s odkazem uvidí vaše povolené inzeráty.`)
};

const en_xml_feed_url_hint = /** @type {(inputs: Xml_Feed_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give this URL to the portal or partner. It includes the secret key — anyone with the link can read your enabled listings.`)
};

/**
* | output |
* | --- |
* | "Give this URL to the portal or partner. It includes the secret key — anyone with the link can read your enabled listings." |
*
* @param {Xml_Feed_Url_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_url_hint = /** @type {((inputs?: Xml_Feed_Url_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Url_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_url_hint(inputs)
	return cs_xml_feed_url_hint(inputs)
});